import { cardsData } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            {cardsData.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-500">{cardsData.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cardsData.items.slice(0, 3).map((item) => (
            <div
              key={item.title}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200/60 transition-all duration-200 cursor-pointer"
            >
              <div className="aspect-[3/2] overflow-hidden bg-background-300">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <span className="inline-block text-xs px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-700 font-medium mb-3">
                  {item.tag}
                </span>
                <h3 className="text-base font-semibold text-foreground-800 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-6">
          {cardsData.items.slice(3, 5).map((item) => (
            <div
              key={item.title}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200/60 transition-all duration-200 cursor-pointer flex flex-col sm:flex-row"
            >
              <div className="sm:w-48 aspect-[3/2] sm:aspect-auto overflow-hidden bg-background-300 flex-shrink-0">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5 flex flex-col justify-center">
                <span className="inline-block text-xs px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-700 font-medium mb-2 w-fit">
                  {item.tag}
                </span>
                <h3 className="text-base font-semibold text-foreground-800 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}